import { Button, Loader, Modal, Table } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import EditAdminDrawer from './admins/Edit';
import PropTypes from 'prop-types';
import {
  fetchAdmins,
  deleteAdmin,
  setCurrentCarrier,
  resetAdmins
} from '@redux/carrierSlices/adminSlice';

const Admins = ({ carrier }) => {
  const [admin, setAdmin] = useState(null);
  const [modal, setModal] = useState(false);
  const { setNotification } = useContext(CarrierContext);
  const dispatch = useDispatch();
  const adminState = useSelector(state => state.admins);

  const { admins, loading, error } = adminState || {};

  useEffect(() => {
    if (carrier?.id) {
      dispatch(setCurrentCarrier(carrier.id));
      dispatch(fetchAdmins(carrier.id));
    }
    return () => {
      dispatch(resetAdmins());
    };
  }, [carrier?.id, dispatch]);

  const handleSave = () => {
    setAdmin(null);
    dispatch(fetchAdmins(carrier.id));
    setNotification(ACTION_MESSAGES.CARRIERS.ADMIN.SAVE);
  };

  const handleDelete = (adminToDelete, e) => {
    e.stopPropagation();
    setModal('delete');
    setAdmin(adminToDelete);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);
    dispatch(deleteAdmin(admin.id))
      .unwrap()
      .then(() => {
        setModal(null);
        setAdmin(null);
        setNotification(ACTION_MESSAGES.CARRIERS.ADMIN.DELETE);
      })
      .catch(() => {
        setModal(null);
        setAdmin(null);
        setNotification(ACTION_MESSAGES.CARRIERS.ADMIN.DELETE_ERROR);
      });
  };

  if (loading && !admins.length) {
    return <Loader />;
  }

  return (
    <>
      <EditAdminDrawer
        admin={admin}
        onClose={() => setAdmin(null)}
        onSave={handleSave}
        show={!modal && !!admin}
      />

      {error && <div style={{ color: 'red', marginBottom: '20px' }}>{error}</div>}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={() =>
            setAdmin({
              first_name: '',
              last_name: '',
              email: '',
              carrier_id: carrier.id
            })
          }
        >
          Add Admin
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name',
            render: admin => `${admin.first_name} ${admin.last_name}`
          },
          {
            id: 'email',
            label: 'Email'
          },
          {
            id: 'actions',
            render: admin => (
              <Button color='RED' inline={true} onClick={e => handleDelete(admin, e)} small={true}>
                Delete
              </Button>
            ),
            styles: { textAlign: 'right' },
            width: 100
          }
        ]}
        data={admins || []}
        onRowClick={setAdmin}
        placeholder='No admins created yet'
      />

      {modal === 'delete' && (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
            setAdmin(null);
          }}
          title={`Delete "${admin.first_name} ${admin.last_name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{admin.first_name} {admin.last_name}"?
          </div>
        </Modal>
      )}
    </>
  );
};

Admins.propTypes = {
  carrier: PropTypes.object
};

export default Admins;
